/**
 * Extract error message from openapi-fetch error object
 */
export function getMessageFromError(error: unknown): string | undefined {
  if (error && typeof error === 'object' && 'message' in error) {
    return (error as { message?: string }).message;
  }
  return undefined;
}
